import "bootstrap/dist/css/bootstrap.min.css";
import "react-calendar/dist/Calendar.css";
import "react-step-progress-bar/styles.css";
import "./styles/tokens.css";
import "./asset/css/calender.css"
import "react-quill/dist/quill.snow.css"; 
import "./asset/css/style.css";
import "./asset/css/newStyle.css";
import "./asset/css/newResponsive.css";
import "./styles/mentorShell.css";
import "./components/common/MentorCard.css";
import "./components/common/MentorButtons.css";
import "./components/common/MentorTable.css";
import "./components/common/StatusBadge.css";
import "./components/common/MentorStates.css";
import "./components/common/MentorSkeleton.css";
import "./components/common/ModalOverride.css";

import { Suspense, useEffect } from "react";
import { Routes, useLocation, useNavigate } from "react-router-dom";
import RoutesArr from "./routes";
import getRoutes from "./pages/auth/getRoutes";
import { useDispatch, useSelector } from "react-redux";
import { setLogin, setLogout } from "./slice/authSlice";
import { asyncLogOut, asyncProfileData } from "./actions/loginAction";
import { jwtDecode } from "jwt-decode";
import VideoUploadProgress from "./components/moduleVideos/videoupload/VideoUploadProgress";

function App() {
  const dispatch = useDispatch();
  const {pathname} = useLocation()
  const isLoggedIn = useSelector((state)=>state.authData.auth)
  const navigate = useNavigate()
  
  useEffect(() => {
    if (localStorage.getItem("oeson_auth")) {
      dispatch(setLogin());
    } else {
      dispatch(setLogout());
    }
  }, [dispatch]);


  useEffect(() => {
    if (isLoggedIn) {
      dispatch(asyncProfileData());
    }
  }, [dispatch, isLoggedIn]);

  useEffect(() => {
    const token = localStorage.getItem("oeson_auth");
    if (!token) return;
    try {
      if (jwtDecode(token).exp < Date.now() / 1000) dispatch(asyncLogOut(navigate));
    } catch (_) {
      ["oeson_auth", "oeson_role", "oeson_roles", "oeson_id", "oeson_session_id"].forEach((key) => localStorage.removeItem(key));
      navigate("/login", { replace: true });
    }
  }, [dispatch, navigate, pathname]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Suspense fallback={<div className="mentor-app-loading"><span />Loading workspace...</div>}>
      <VideoUploadProgress />
      <Routes>{getRoutes(RoutesArr)}</Routes>
    </Suspense>
  );
}

export default App;
